import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { DocumentoForm } from '.'
import DocumentosList from './DocumentosList'
import DocumentosListLocal from './DocumentosListLocal'
import { Grid } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(6),
    marginTop: theme.spacing(2)
  }
}))

const DocumentosCard = props => {
  const classes = useStyles()
  const [status, setStatus] = useState('list')
  const ListComponent = props.onChangeDocumentosLocais
    ? DocumentosListLocal
    : DocumentosList
  const { onChangeFormularioAberto } = props

  useEffect(() => {
    if (!onChangeFormularioAberto) return
    onChangeFormularioAberto(status === 'new')
    return () => onChangeFormularioAberto(false)
  }, [status, onChangeFormularioAberto])

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        {status === 'list' ? (
          <ListComponent {...props} onClickNew={() => setStatus('new')} />
        ) : (
          <DocumentoForm {...props} onGoBack={() => setStatus('list')} />
        )}
      </Grid>
    </div>
  )
}
export default React.memo(DocumentosCard)
